import ReviewPhoto from "../../../assets/images/jpeg/build/prototype-review.jpg";

const stages = [
  {
    num: "01",
    code: "BRIEF",
    title: "Submit the challenge",
    text:
      "Share what is happening today, who it affects and what better should look like.",
  },
  {
    num: "02",
    code: "MAP",
    title: "Diagnose the problem",
    text:
      "We study the workflow, users, constraints and opportunity before proposing technology.",
  },
  {
    num: "03",
    code: "SHAPE",
    title: "Shape the product",
    text:
      "We define the smallest useful product and assemble the right multidisciplinary team.",
  },
  {
    num: "04",
    code: "BUILD",
    title: "Build with your team",
    text:
      "Design, prototyping, engineering, testing and feedback happen in visible cycles.",
  },
  {
    num: "05",
    code: "PROVE",
    title: "Prove the next move",
    text:
      "You see a working first version and decide what to launch, improve or scale next.",
  },
];

const BuildMethodSection = () => {
  return (
    <section className="apl-section apl-section-dark" id="method">
      <div className="apl-shell">
        <div className="apl-center-head apl-reveal">
          <div className="apl-eyebrow">The Lab method</div>
          <h2>One challenge. Five visible stages.</h2>
          <p>
            You stay close to the work. Every stage turns uncertainty into
            something clearer, more useful and easier to test.
          </p>
        </div>

        <div className="apl-method apl-reveal">
          {stages.map((stage) => (
            <article className="apl-method-step" key={stage.code}>
              <small>{stage.num}</small>
              <div className="apl-method-code">{stage.code}</div>
              <h3>{stage.title}</h3>
              <p>{stage.text}</p>
            </article>
          ))}
        </div>

        <figure className="apl-method-photo apl-reveal">
          <img
            src={ReviewPhoto}
            alt="An African product team presenting a working AI product prototype to a business client"
            loading="lazy"
          />
          <figcaption>
            <small>Built in the open</small>
            Progress becomes visible early, so feedback shapes the product
            before assumptions become expensive.
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default BuildMethodSection;
